import { render, staticRenderFns } from "./SubGridSitecore.vue?vue&type=template&id=485b7fd9"
import script from "./SubGridSitecore.vue?vue&type=script&lang=js"
export * from "./SubGridSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports